import { React } from "react";
import { Button} from "antd";
import Iconmoon from "../../../../haberwater-ui/src/Components/IconsFiles/icon";
import styled from "styled-components";

const EmptyState = (props) => {

    let {
        img,
        label,
        heading,
        subHeading,
        refresh,
        type
    } = props;
    
    const Header = styled.div`
    padding-top: "50px";
    padding-bottom: "50px";
    .ImgStyle{
                display: "block";
                margin-left: "auto";
                margin-right: "auto"
                opacity:"70%";
                width: "341.62px";
                height:"225.84px";
    }
    .Heading{
                font-family: "var(--sf-pro-display-m)",
                font-weight: "500",
                font-size: "14px",
                height: "16px",
                color: "#A19F9D",
                padding-top: "20px",
                display: "block",
                margin-left: "auto",
                margin-right: "auto",
                width: "125px",
                text-align: "center"
    }
    .SubHeading{
                padding-top: "30px",
                        font-family: "var(--sf-pro-display-m)",
                        font-weight: "400",
                        font-size: "12px",
                        height: "20px",
                        color: "#A19F9D",
                        display: "block",
                        margin-left: "auto",
                        margin-right: "auto",
                        width: "311px",
                        text-align: "center"
    }
    .ReloadButton{
        margin-left: "auto",
                margin-right: "auto",
                display: "block",
                margin-top: "20px"
    }
    `;
    const reload = () => {
        refresh();
    };

    return  img && (
        <div style={{
            paddingTop: "50px",
            paddingBottom: "50px"}}
        >
            <img 
            style={{display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                opacity:"70%",
                width: "341.62px",
            height:"225.84px"}}
            src={img}
            alt=""
            />
            <div 
            style={{
                fontFamily: "var(--sf-pro-display-m)",
                fontWeight: "500",
                fontSize: "14px",
                height: "16px",
                color: "#A19F9D",
                paddingTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: (type == "PO" ? "220px" :"150px"),
                textAlign: "center",
           }}
           >{heading}
            </div>
            <div style={{
                        paddingTop: "30px",
                        fontFamily: "var(--sf-pro-display-m)",
                        fontWeight: "400",
                        fontSize: "12px",
                        height: "20px",
                        color: "#A19F9D",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        width: "311px",
                        textAlign: "center"}}
                        >
            { subHeading }
            </div>
            {label === "connectionAPIError" && 
                <Button
                key="1"
                className="themeBtn"
                onClick={reload}
                style={{
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                marginTop: "35px"
            }}
                >
                <Iconmoon icon="Reload" size={14} color="#ffffff" />
                Reload
                </Button>
            }
        </div>
    );
};

export default EmptyState;
 